<template>
  <transition
    name="unpin-slide"
    @after-leave="afterLeave"
  >
  <div v-if="!isLeaving" class="info-card" :class="{ expanded: expanded.medication, collapsed: !expanded.medication }">
      <div class="info-card-content">
      <!-- Collapsed state -->
      <div v-if="!expanded.medication" class="collapsed-content">
        <div class="info-row">
          <div class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M5.625 18C4.05833 18 2.72917 17.4542 1.6375 16.3625C0.545833 15.2708 0 13.9417 0 12.375C0 11.625 0.141667 10.9083 0.425 10.225C0.708333 9.54167 1.16667 8.93333 1.65 8.4L8.4 1.65C8.93333 1.11667 9.54167 0.708333 10.225 0.425C10.9083 0.141667 11.625 0 12.375 0C13.9417 0 15.2708 0.545833 16.3625 1.6375C17.4542 2.72917 18 4.05833 18 5.625C18 6.375 17.8583 7.09167 17.575 7.775C17.2917 8.45833 16.8833 9.06667 16.35 9.6L9.6 16.35C9.06667 16.8833 8.45833 17.2917 7.775 17.575C7.09167 17.8583 6.375 18 5.625 18ZM12.275 10.85L14.95 8.2C15.2833 7.86667 15.5417 7.475 15.725 7.025C15.9083 6.575 16 6.10833 16 5.625C16 4.625 15.6458 3.77083 14.9375 3.0625C14.2292 2.35417 13.375 2 12.375 2C11.8917 2 11.425 2.09167 10.975 2.275C10.525 2.45833 10.1333 2.71667 9.8 3.05L7.15 5.725L12.275 10.85ZM5.625 16C6.10833 16 6.575 15.9083 7.025 15.725C7.475 15.5417 7.86667 15.2833 8.2 14.95L10.85 12.275L5.725 7.15L3.05 9.8C2.71667 10.1333 2.45833 10.525 2.275 10.975C2.09167 11.425 2 11.8917 2 12.375C2 13.375 2.35417 14.2292 3.0625 14.9375C3.77083 15.6458 4.625 16 5.625 16Z" fill="#25B8C2"/>
            </svg>
          </div>
          <p class="info-text-title">Active Medication:</p>
          <div class="flex flex-row items-center gap-2 ml-auto">
            <div class="action-icon" @click.stop="toggleCard('medication')">
              <img src="@/assets/cardActions/expand.svg" alt="Expand" />
            </div>
            <div class="drag-handle action-icon">
              <img src="@/assets/cardActions/move.svg" alt="Move" />
            </div>
          </div>
        </div>
      </div>

      <!-- Expanded state -->
      <div v-else class="medication-card-expanded">
        <!-- Header row: icon + title + pin -->
        <div class="medication-header">
          <div class="icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M5.625 18C4.05833 18 2.72917 17.4542 1.6375 16.3625C0.545833 15.2708 0 13.9417 0 12.375C0 11.625 0.141667 10.9083 0.425 10.225C0.708333 9.54167 1.16667 8.93333 1.65 8.4L8.4 1.65C8.93333 1.11667 9.54167 0.708333 10.225 0.425C10.9083 0.141667 11.625 0 12.375 0C13.9417 0 15.2708 0.545833 16.3625 1.6375C17.4542 2.72917 18 4.05833 18 5.625C18 6.375 17.8583 7.09167 17.575 7.775C17.2917 8.45833 16.8833 9.06667 16.35 9.6L9.6 16.35C9.06667 16.8833 8.45833 17.2917 7.775 17.575C7.09167 17.8583 6.375 18 5.625 18ZM12.275 10.85L14.95 8.2C15.2833 7.86667 15.5417 7.475 15.725 7.025C15.9083 6.575 16 6.10833 16 5.625C16 4.625 15.6458 3.77083 14.9375 3.0625C14.2292 2.35417 13.375 2 12.375 2C11.8917 2 11.425 2.09167 10.975 2.275C10.525 2.45833 10.1333 2.71667 9.8 3.05L7.15 5.725L12.275 10.85ZM5.625 16C6.10833 16 6.575 15.9083 7.025 15.725C7.475 15.5417 7.86667 15.2833 8.2 14.95L10.85 12.275L5.725 7.15L3.05 9.8C2.71667 10.1333 2.45833 10.525 2.275 10.975C2.09167 11.425 2 11.8917 2 12.375C2 13.375 2.35417 14.2292 3.0625 14.9375C3.77083 15.6458 4.625 16 5.625 16Z" fill="#25B8C2"/>
            </svg>
          </div>
          <p class="info-text-title">Active Medications:</p>
          <div class="header-action-icons">
            <div v-if="!isCardPinned" class="action-icon" @click.stop="handlePinCard">
              <img src="@/assets/cardActions/pin.svg" alt="Pin" />
            </div>
            <div v-if="isCardPinned" class="action-icon" @click.stop="startUnpin">
              <img src="@/assets/cardActions/unpin.svg" alt="Unpin" />
            </div>
          </div>
        </div>

        <!-- Content: medications list -->
        <div class="medication-content">
          <div v-if="isLoading" class="loading-state">
            <p class="info-text">Loading medications...</p>
          </div>
          <div v-else-if="displayMedications.length > 0" class="medications-list">
            <div
              v-for="medication in displayMedications"
              :key="medication.id || medication.name"
              class="medication-item"
            >
              <p class="medication-name-title">{{ medication.name || medication.brandName }}</p>
              <p v-if="medication.dose || (medication.frequencyNumber && medication.frequencyPeriod)" class="info-text-medication-info-text">
                <template v-if="medication.dose">{{ medication.dose }}</template><template v-if="medication.dose && medication.frequencyNumber && medication.frequencyPeriod">, </template><template v-if="medication.frequencyNumber && medication.frequencyPeriod">{{ medication.frequencyNumber }} {{ medication.frequencyPeriod }}</template>
                <span v-if="medication.route"> | {{ medication.route }}</span>
              </p>
              <p v-if="medication.startDate && formatDate(medication.startDate) !== 'N/A'" class="info-text-medication-info-text">
                Started on {{ formatDate(medication.startDate) }}
              </p>
            </div>
          </div>
          <div v-else class="empty-state">
            <p class="info-text">There are no medications recorded for this patient yet.</p>
          </div>
        </div>
      </div>
      </div>
      <div class="card-expand" :class="{ 'justify-end': !showFooter, 'justify-between': showFooter }">
        <FoldableButton v-if="showFooter" customized_class="drag-handle" text="Move">
          <template #prefix>
            <img src="@/assets/cardActions/move.svg" alt="Move" />
          </template>
        </FoldableButton>
        <div class="flex flex-row gap-1 justify-end">
          <FoldableButton v-show="false" text="Reconcile" @click="handleReconcile">
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M14.625 11.235C14.61 11.235 14.6025 11.235 14.5875 11.2425C14.4 9.975 13.32 9 12 9C10.95 9 10.05 9.6225 9.63 10.515C8.445 10.575 7.5 11.55 7.5 12.75C7.5 13.995 8.505 15 9.75 15L14.625 14.985C15.66 14.985 16.5 14.145 16.5 13.11C16.5 12.075 15.66 11.235 14.625 11.235ZM14.6325 13.5H9.75C9.3375 13.5 9 13.1625 9 12.75C9 12.3375 9.3375 12 9.75 12H10.6875V11.8125C10.6875 11.085 11.2725 10.5 12 10.5C12.7275 10.5 13.3125 11.085 13.3125 11.8125V12.75C13.3125 12.75 14.625 12.75 14.6325 12.75C14.8425 12.75 15.0075 12.915 15.0075 13.125C15 13.3275 14.835 13.5 14.6325 13.5ZM6 3.195V4.7625C4.2525 5.385 3 7.0425 3 9C3 10.3275 3.585 11.505 4.5 12.33V10.5H6V15H1.5V13.5H3.5475C2.295 12.405 1.5 10.8 1.5 9C1.5 6.2025 3.4125 3.8625 6 3.195ZM13.5 4.5H11.4525C12.525 5.445 13.26 6.7575 13.4475 8.25H11.9325C11.76 7.23 11.235 6.3375 10.5 5.67V7.5H9V3H13.5V4.5Z" fill="#374957"/>
              </svg>
            </template>
          </FoldableButton>
          <FoldableButton text="Add new" @click="handleAddNew">
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 1V13M1 7H13" stroke="#1E4670" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </template>
          </FoldableButton>
          <FoldableButton text="Edit" @click="handleEditLast">
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1727 2.37431C14.3169 2.59265 14.2928 2.88936 14.1006 3.08157L7.20634 9.97586C7.13567 10.0465 7.04744 10.0971 6.95075 10.1224L4.07942 10.8724C3.98578 10.8968 3.88924 10.8963 3.79854 10.8732C3.70212 10.8487 3.61229 10.7986 3.53953 10.7259C3.39832 10.5846 3.34257 10.3792 3.39304 10.1859L4.14304 7.31463C4.16514 7.23002 4.20661 7.14646 4.26397 7.08091L11.1838 0.164752C11.2444 0.10418 11.3174 0.0588451 11.3968 0.0312234C11.4556 0.0107432 11.518 0 11.5816 0C11.7307 0 11.8738 0.0592631 11.9793 0.164752L14.1006 2.28607C14.1281 2.31353 14.1521 2.34312 14.1727 2.37431ZM12.9074 2.68382L11.5816 1.358L5.19294 7.74662L4.7242 9.54119L6.51877 9.07244L12.9074 2.68382Z" fill="#374957"/>
                <path d="M12.8126 11.1827C13.0176 9.42952 13.0829 7.66408 13.0083 5.90309C13.0047 5.81878 13.0364 5.73674 13.0961 5.67706L13.8336 4.93957C13.9243 4.84889 14.0792 4.90646 14.0877 5.03441C14.2264 7.12665 14.1738 9.22839 13.93 11.3134C13.7525 12.8303 12.5343 14.0191 11.0253 14.1877C8.42532 14.4783 5.73782 14.4783 3.13788 14.1877C1.62884 14.0191 0.410592 12.8303 0.233178 11.3134C-0.0777259 8.6552 -0.0777259 5.9698 0.233178 3.31157C0.410592 1.79467 1.62884 0.605917 3.13789 0.437259C5.1102 0.216824 7.1329 0.163611 9.12955 0.277621C9.25823 0.284969 9.31689 0.440681 9.22575 0.53182L8.48134 1.27624C8.42231 1.33526 8.34138 1.36695 8.25796 1.36414C6.58814 1.30782 4.90697 1.37154 3.26284 1.5553C2.26526 1.66679 1.46615 2.454 1.35056 3.44226C1.04981 6.01365 1.04981 8.61134 1.35056 11.1827C1.46615 12.171 2.26526 12.9582 3.26284 13.0697C5.77973 13.351 8.38341 13.351 10.9003 13.0697C11.8979 12.9582 12.697 12.171 12.8126 11.1827Z" fill="#374957"/>
              </svg>
            </template>
          </FoldableButton>
          <FoldableButton text="Variable Properties" @click="handleVariableProperties">
            <template #prefix>
              <img src="@/assets/cardActions/pt_variable.svg" alt="Variable Properties" />
            </template>
          </FoldableButton>
          <FoldableButton v-show="false" text="Send to">
            <template #prefix>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none">
                <path d="M0 12V0L14.25 6L0 12ZM1.5 9.75L10.3875 6L1.5 2.25V4.875L6 6L1.5 7.125V9.75Z" fill="#374957"/>
              </svg>
            </template>
          </FoldableButton>
        </div>
      </div>
  </div>
</transition>

<PatientVariableDialog
  v-model:visible="showPtVariablesDialog"
  :ptVariables="ptVariables"
  :patientId="patientId"
/>
</template>
<script setup>
import { ref, computed } from 'vue';
import { useCardActions } from '@/composables/useCardActions';
import { useMyPatientsStore } from '@/store/helpers';
import PatientVariableDialog from './PatientVariableDialog.vue';

// Define props
const props = defineProps({
  patient: {
    type: String,
    default: ''
  },
  cardData: {
    type: Object,
    default: () => ({})
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  context: {
    type: String,
    default: 'pegboard'
  },
  medications: {
    type: Array,
    default: () => []
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  externalVariableDialog: {
    type: Boolean,
    default: false
  }
})

// Define emits
const emit = defineEmits(['unpin-card', 'pin-card', 'add-new', 'edit', 'discontinue', 'reconcile', 'open-variable-dialog']);

const { patientInfoStore } = useMyPatientsStore();
const { isCardPinned, handlePinCard, handleUnpinCard } = useCardActions(props, emit);

// Patient variable dialog
const ptVariables = ['pt_meds']
const showPtVariablesDialog = ref(false)
const patientId = computed(() => props.patient || '')

const handleVariableProperties = () => {
  if (!props.externalVariableDialog) {
    showPtVariablesDialog.value = true
  }
  emit('open-variable-dialog', ptVariables)
};


const isLeaving = ref(false);


const startUnpin = () => {
  if(props.showFooter){
    isLeaving.value = true; // triggers the leave animation
  } else {
    handleUnpinCard()
  }
};

// This is called after the leave animation finishes
const afterLeave = () => {
  emit('unpin-card', props.cardData); // parent removes the card
};


const expanded = ref({
  medication: true,
})

const toggleCard = (cardType) => {
  expanded.value[cardType] = !expanded.value[cardType]
}

// Display medications - prioritize props.medications (from parent) over store data
// Only show first 3 items for the card display
const displayMedications = computed(() => {
  let medications = [];

  // If medications prop is provided and has items, use it
  if (props.medications && props.medications.length > 0) {
    medications = props.medications;
  } else {
    // Otherwise fall back to store data for backward compatibility
    const storeData = patientInfoStore.getters.getMedicationCardData(props.patient);
    if (storeData && storeData.allMedications && storeData.allMedications.length > 0) {
      medications = storeData.allMedications;
    }
    // Check for legacy format - only if it's NOT the "No medications found" placeholder
    const isPlaceholder = storeData?.displayName === 'No medications found';
    const hasValidData = storeData?.displayName && !isPlaceholder;
    const hasDosageInfo = storeData?.dosageInstructions || storeData?.dosage || storeData?.instructions;
    if (storeData && (hasValidData || hasDosageInfo) && !isPlaceholder) {
      medications = [{
        name: storeData.displayName || storeData.brandName,
        dose: storeData.dosage || storeData.dosageInstructions?.split(',')[0],
        frequency: storeData.instructions || storeData.dosageInstructions?.split(',')[1]?.trim(),
        startDate: storeData.startedOn || storeData.formattedStartDate
      }];
    }
  }

  return medications;
});

// Format date for display
const formatDate = (dateStr) => {
  if (!dateStr || dateStr === 'N/A') return 'N/A';
  try {
    const date = new Date(dateStr);
    // Check if date is valid
    if (isNaN(date.getTime())) return 'N/A';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  } catch (e) {
    return 'N/A';
  }
};

// Handle add new button click
const handleAddNew = () => {
  emit('add-new');
};

// Handle reconcile button click
const handleReconcile = () => {
  emit('reconcile');
};

// Handle edit button click
const handleEdit = (medication) => {
  emit('edit', medication);
};

// Handle edit last medication button click
const handleEditLast = () => {
  const lastMedication = displayMedications.value[displayMedications.value.length - 1];
  emit('edit', lastMedication);
};

</script>


<style scoped>

.pin-toggle {
  position: relative;
  cursor: pointer;
}

.pin-toggle .icon {
  position: absolute;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.pin-toggle .unpin {
  opacity: 0;
  transform: scale(0.8);
}

/* Hover effect */
.pin-toggle:hover .pin {
  opacity: 0;
  transform: scale(1);
}

.pin-toggle:hover .unpin {
  opacity: 1;
  transform: scale(1);
}


.unpin-slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.unpin-slide-leave-to {
  transform: translateX(-100%) scale(0.95);
  opacity: 0;
}

.peg-board-title {
font-family: 'Inter', sans-serif;
font-weight: 500;
font-size: 22px;
color: #ffffff;
text-align: center;
margin-bottom: 16px;
}

.peg-board-content {
display: flex;
flex-direction: column;
gap: 6px;
overflow-y: auto;
padding: 0 8px;
}

.info-card {
background-color: white;
border-radius: 5px;
padding: 12px 16px;
box-shadow: 0px 1px 25px 0px rgba(74, 74, 74, 0.15);
}

.info-card-content {
display: flex;
justify-content: space-between;
align-items: flex-start;
gap: 16px;
}

.medication-card-expanded {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  flex: 1;
}

/* Header row: icon + title + pin */
.medication-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.medication-header .info-text-title {
  flex: 1;
}

.header-action-icons {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: auto;
}

.medication-content {
  margin-left: 32px;
}

.info-card-content-col-group {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.info-row-group {
display: flex;
flex-direction: column;
gap: 10px;
flex-grow: 1;
}

.info-row {
display: flex;
align-items: center;
gap: 8px;
}

.icon-container {
background-color: #f2f2f2;
border-radius: 4px;
width: 24px;
height: 24px;
display: flex;
justify-content: center;
align-items: center;
}

.icon-style {
width: 20px;
height: 20px;
}

.info-text {
font-family: 'Inter', sans-serif;
font-size: 14px;
color: #333333;
letter-spacing: 0.25px;
line-height: 20px;
}

.action-icons {
display: flex;
flex-direction: column;
gap: 4px;
}

.action-icon {
width: 24px;
height: 24px;
cursor: pointer;
}

.appointment-date {
display: flex;
flex-direction: column;
align-items: center;
justify-content: space-between;
width: 50px;
height: 64px;
border-radius: 5px;
background-color: #ffffff;
box-shadow: 0px 1px 15px 0px rgba(74, 74, 74, 0.1);
overflow: hidden;
}

.month {
background-color: #004879;
color: white;
width: 100%;
text-align: center;
padding: 2px 0;
font-size: 14px;
}

.day {
color: rgba(0, 0, 0, 0.65);
text-align: center;
font-family: Lato;
font-size: 20px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 120% */
text-transform: capitalize;
height: 24px;
}

.weekday {
font-size: 12px;
color: rgba(0, 0, 0, 0.65);
line-height: 1;
padding-bottom: 3px;
}

.appointment-details {
  flex-grow: 1;
}

.detail-title {
  font-size: 12px;
  color: #666;
}
.detail-text {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}
.action-icons-appointment {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 20px;
}
.info-text-title {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  color: #666;
  margin: 0;
  line-height: 24px;
}
.info-text-large {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

/* Badge for billing preference */
.badge {
color: #25B8C2;
font-family: Inter;
font-size: 10px;
font-style: normal;
font-weight: 500;
line-height: 12px; /* 120% */
letter-spacing: 0.25px;
display: flex;
padding: 4px 8px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
}

.badge-default {
border-radius: 20px;
background: #EBFFF8;
width: 68px;
}


/* Expanded card footer visibility with hover expand animation */
.card-expand {
  display: flex;
  align-items: center;
  gap: 16px;
  /* animation base state */
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  padding-top: 0;
  margin-top: 0;
  border-top: 1px dashed var(--DividerGray, #C4C4C4);
  border-top-color: transparent;
  pointer-events: none;
  transition: max-height 300ms linear,
              opacity 300ms linear,
              padding-top 300ms linear,
              padding-bottom 300ms linear,
              margin-top 300ms linear,
              border-top-color 300ms linear;
}

.info-card.expanded:hover .card-expand {
  /* ensure enough room for actions */
  max-height: 80px;
  opacity: 1;
  padding-top: 10px;
  padding-bottom: 4px;
  margin-top: 10px;
  border-top-color: var(--DividerGray, #C4C4C4);
  pointer-events: auto;
}

.expand-action {
display: flex;
align-items: center;
gap: 8px;
color: #1B79A0;
cursor: pointer;
padding: 4px 10px;
border-radius: 5px;
}

.expand-action span {
color: var(--color-Darkblue-000, #1E4670);
text-align: center;
font-family: 'Inter', sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
text-decoration-line: underline;
text-decoration-style: solid;
text-decoration-skip-ink: none;
text-decoration-thickness: auto;
text-underline-offset: auto;
text-underline-position: from-font;
}

/* Expand buttons - icon only, expand on hover */
.add-new-expand,
.reconcile-expand,
.variable-expand,
.edit-expand,
.send-expand {
  display: flex;
  align-items: center;
  width: 26px;
  overflow: hidden;
  padding: 4px;
  justify-content: center;
  transition: width 0.25s ease, padding 0.25s ease, gap 0.25s ease;
  gap: 0;
}

.add-new-expand:hover,
.reconcile-expand:hover,
.variable-expand:hover,
.edit-expand:hover,
.send-expand:hover {
  padding: 4px 10px;
  justify-content: flex-start;
  gap: 6px;
}

.add-new-expand:hover { width: 92px; }
.reconcile-expand:hover { width: 110px; }
.variable-expand:hover { width: 160px; }
.edit-expand:hover { width: 65px; }
.send-expand:hover { width: 90px; }

.add-new-expand span,
.reconcile-expand span,
.variable-expand span,
.edit-expand span,
.send-expand span {
  white-space: nowrap;
  opacity: 0;
  min-width: 0;
  transition: opacity 0.2s ease;
  transition-delay: 0.05s;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #1E4670;
  text-decoration: underline;
}

.add-new-expand:hover span,
.reconcile-expand:hover span,
.variable-expand:hover span,
.edit-expand:hover span,
.send-expand:hover span {
  opacity: 1;
}

.add-new-expand svg,
.reconcile-expand svg,
.variable-expand img,
.edit-expand svg,
.send-expand svg {
  flex-shrink: 0;
}

/* Move expand button */
.move-expand {
  display: flex;
  align-items: center;
  width: 26px;
  overflow: hidden;
  padding: 4px;
  justify-content: center;
  transition: width 0.4s ease, padding 0.4s ease, gap 0.4s ease;
  gap: 0;
}

.move-expand:hover {
  padding: 4px 10px;
  justify-content: flex-start;
  gap: 6px;
  width: 78px;
}

.move-expand span {
  white-space: nowrap;
  opacity: 0;
  min-width: 0;
  transition: opacity 0.3s ease;
  transition-delay: 0.1s;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #1E4670;
  text-decoration: underline;
}

.move-expand:hover span {
  opacity: 1;
}

.move-expand img {
  flex-shrink: 0;
}

.info-text-medication-info-text {
  color: var(--SecondaryBlack, #666);
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0.1px;
  padding-left: 8px;
}

/* Add New Button */
.add-new-btn {
  background-color: #004879;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-new-btn:hover {
  background-color: #1e4670;
}

/* Medications List */
.medications-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-height: 156px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  width: 100%;
}

.medication-item {
  width: 100%;
  flex-shrink: 0;
  border: none;
  background-color: white;
  padding: 2px 0;
}

/* Scrollbar styling - overlay style */
.medications-list::-webkit-scrollbar {
  width: 0px;
}

.medications-list:hover::-webkit-scrollbar {
  width: 4px;
}

.medications-list::-webkit-scrollbar-track {
  background: transparent;
}

.medications-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 2px;
}

.medications-list::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.medication-name-title {
  overflow: hidden;
  color: var(--TrueBlack, #333);
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  align-self: stretch;
}

.empty-state {
  padding: 8px 0;
  text-align: center;
  color: #999999;
  font-style: italic;
  margin-left: -32px;
}

.loading-state {
  padding: 8px 0;
  text-align: center;
  color: #666666;
  font-style: italic;
  margin-left: -32px;
}

.action-icon {
  width: 28px;          /* w-7 */
  height: 28px;         /* h-7 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;   /* rounded-[5px] */
  padding: 5px;         /* pd-5 (assuming you meant padding) */
  cursor: pointer;
  transition: background-color 0.2s; /* duration-200 transition-colors */
}

.action-icon:hover,
.expand-action:hover {
  background-color: #E5F1FB; /* hover:bg-[#E5F1FB] */
}

/* Fix action-icons to stay in position */
.action-icons {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

/* Fix flex-1 width constraint */
.flex-1 {
  flex: 1;
  min-width: 0;
}

/* unified pin toggle */
.pin-toggle { position: relative; cursor: pointer; }
.pin-toggle .icon { position: absolute; transition: opacity 0.3s ease, transform 0.3s ease; }
.pin-toggle .unpin { opacity: 0; transform: scale(0.8); }
.pin-toggle:hover .pin { opacity: 0; transform: scale(1); }
.pin-toggle:hover .unpin { opacity: 1; transform: scale(1); }

</style>
